import { Routes } from '@angular/router';
import { CheckTheInformationComponent } from './check-the-information/check-the-information.component';
import { ContactTheRegistryComponent } from './contact-the-registry/contact-the-registry.component';
import { Error500Component } from './error-500/error-500.component';
import {
  CHECK_THE_INFORMATION,
  CONTACT_THE_REGISTRY,
  ERROR_500,
  INFORMACION_FASECOLDA,
  PROBLEMAS_TECNICOS,
  SARLAFT_DENIED,
} from './final-pages.constants';
import { InformacionFasecoldaComponent } from './informacion-fasecolda/informacion-fasecolda.component';
import { ProblemasTecnicosComponent } from './problemas-tecnicos/problemas-tecnicos.component';
import { SarlaftDeniedComponent } from './sarlaft-denied/sarlaft-denied.component';

export const finalPagesChildrenRoutes: Routes = [
  { path: SARLAFT_DENIED, component: SarlaftDeniedComponent },
  { path: CONTACT_THE_REGISTRY, component: ContactTheRegistryComponent },
  { path: CHECK_THE_INFORMATION, component: CheckTheInformationComponent },
  { path: ERROR_500, component: Error500Component },
  { path: PROBLEMAS_TECNICOS, component: ProblemasTecnicosComponent },
  { path: INFORMACION_FASECOLDA, component: InformacionFasecoldaComponent },
];
